module.exports = __webpack_public_path__ + "static/img/A.O.史密斯橱下冷热即饮净水机DR4000DC1.0aaefd92.png";